var exports = {
  "i": "ConnectionNagbar.module__message___VEtHc3",
  "q": "ConnectionNagbar.module__indicator___VEtHc3",
};

module.exports = exports;
